module.exports = __webpack_public_path__ + "img/recycle_blue.dcbd023d.svg";